module.exports = __webpack_public_path__ + "img/appgallery_download-icon.d41c7d0f.png";